module.exports = __webpack_public_path__ + "media/images/writer/community/button@2x-5e80b0cc91b3ffe8c61d9dc3d0d14e09.png";